import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FindErrorItem, FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { CreateChancel, CustomizedSwitch, EditWithIcon, InputMain, SimpleTooltip } from 'components';
import { systemItemStyles } from './styles';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, systemActions } from 'store';
import { ConnectStripe } from './modals/connectStripe';
import { decryptWithKey } from 'utils/decrypt';

const ACTION_TYPE = 'STRIPE_SETTINGS';
export const Stripe = () => {
    const { handleSubmit, control, reset, setError, clearErrors } = useForm();
    const [editStripe, setEditStripe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const stripe = useSelector((state) => state.system.company);
    const classes = systemItemStyles();
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const [connect, setConnect] = useState(false);
    const [decryptedPublishableKey, setDecryptedPublishableKey] = useState('');
    const [decryptedSecretKey, setDecryptedSecretKey] = useState('');

    useEffect(() => {
        if (stripe?.stripePk && stripe?.stripeSK) {
            setConnect(stripe?.stripeIsActive);
            Promise.all([
                decryptWithKey(stripe.stripePk, process.env.REACT_APP_ENCRYPTION_SK_KEY),
                decryptWithKey(stripe.stripeSK, process.env.REACT_APP_ENCRYPTION_SK_KEY),
            ])
                .then(([pk, sk]) => {
                    setDecryptedPublishableKey(pk);
                    setDecryptedSecretKey(sk);
                    reset({ publishableKey: pk, secretKey: sk });
                })
                .catch((e) => console.error('Failed to decrypt Stripe keys:', e.message));
        }
    }, [stripe]);

    useEffect(() => {
        if (success) {
            setEditStripe(false);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
        if (backError?.error === 'Invalid API Key provided') {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
            setError('secretKey', {
                type: 'required',
                message: backError?.error,
            });
        }
    }, [success, backError]);

    const handleEdit = (data) => {
        dispatch(
            systemActions.stripeSettings({
                settingsType: 'stripe',
                isActive: connect,
                publishableKey: data.publishableKey,
                secretKey: data.secretKey,
            })
        );
    };

    const handleSetCalendarStatus = () => {
        setConnect(!connect);
        dispatch(
            systemActions.stripeSettings({
                settingsType: 'stripe',
                isActive: false,
                publishableKey: decryptedPublishableKey,
                secretKey: decryptedSecretKey,
            })
        );
    };

    return (
        <div>
            {/*<div style={{ marginTop: 32 }}>*/}
            {/*<p className="integration-type-title">Stripe Integration</p>*/}
            <div className="office-ally-box">
                <div className="space-between" style={{ padding: 16 }}>
                    <div className={classes.iconAndTitle}>
                        <img src={Images.stripe} alt="officeAlly" />
                        <p>Stripe</p>
                    </div>
                    {stripe?.stripeIsActive ? (
                        <div className={classes.iconAndTitle} style={{ gap: 16, height: 32 }}>
                            {!editStripe && (
                                <EditWithIcon
                                    handleClick={() => {
                                        setEditStripe(!editStripe);
                                        clearErrors();
                                    }}
                                />
                            )}
                            <SimpleTooltip title={<p>{'Disconnect Stripe'}</p>} placement="top-start">
                                <CustomizedSwitch checked={connect} handleClick={handleSetCalendarStatus} />
                            </SimpleTooltip>
                        </div>
                    ) : (
                        <button onClick={() => open(<ConnectStripe />)} className={classes.connectBtn}>
                            Connect
                        </button>
                    )}
                </div>

                {editStripe && stripe?.stripeIsActive && (
                    <div className="edit-office-ally-connection">
                        <form onSubmit={handleSubmit(handleEdit)}>
                            <div className="flex-align-center" style={{ gap: 16 }}>
                                <InputMain
                                    label={'Publishable Key (PK)*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="publishableKey"
                                    type="text"
                                    control={control}
                                    placeholder="Publishable Key (PK)"
                                    rules={{
                                        required: 'Publishable Key is required.',
                                    }}
                                />
                                <InputMain
                                    label={'Secret Key (SK)*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="secretKey"
                                    type="text"
                                    showPassword={showPassword}
                                    control={control}
                                    placeholder="Password"
                                    rules={{
                                        required: 'Secret Key is required.',
                                    }}
                                    onClickIconEnd={() => setShowPassword((prev) => !prev)}
                                />
                            </div>
                            <div style={{ marginTop: 12 }}>
                                <CreateChancel
                                    justifyContent={'flex-end'}
                                    type="submit"
                                    loader={!!loader.length}
                                    create={'Save'}
                                    chancel={'Cancel'}
                                    onClose={() => {
                                        setEditStripe(false);
                                        reset({
                                            publishableKey: decryptedPublishableKey,
                                            secretKey: decryptedSecretKey,
                                        });
                                    }}
                                    buttonWidth={'100px'}
                                />
                            </div>
                        </form>
                    </div>
                )}
            </div>
            {/*</div>*/}
        </div>
    );
};
